module.exports = __webpack_public_path__ + "img/moderator.2f38e327.svg";